import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=d8b680f8&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=d8b680f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b680f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8b680f8')) {
      api.createRecord('d8b680f8', component.options)
    } else {
      api.reload('d8b680f8', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=d8b680f8&scoped=true&", function () {
      api.rerender('d8b680f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZJivm9L9rg0E/JS/comp/CookieBox.vue"
export default component.exports